import { useContext } from 'react';
import { ProductInfoAndContent } from '../../api/getProducts';
import { SingleOfferStateContext } from './SingleOfferStateProvider';

const useProductContent = (): ProductInfoAndContent | undefined => {
  const singleOfferState = useContext(SingleOfferStateContext);
  return singleOfferState?.productContent;
};

export default useProductContent;
